

























































import {Component, Mixins, Prop} from 'vue-property-decorator';
import {TranslateResult} from 'vue-i18n';
import PriceCard from '@/components/ui/PriceCard.vue';
import TranslatedRouter from '@/mixins/TranslatedRouter';

@Component({
	components: {
		'v-price-card': PriceCard
	}
})
export default class PricingPlans extends Mixins(TranslatedRouter) {
	@Prop({default: true}) readonly showButton: boolean;

	get cards(): TranslateResult {
		return this.$t('pricing.tarifs');
	}

	get absolutePath() {
		return serverVariables.httpRequest.baseUrl;
	}

	get fullPrice() {
		return this.absolutePath + '/dist/pdf/gdpr.pdf';
	}

}
